<template>
  <li @click="onClickMenuItem">
    <slot></slot>
  </li>
</template>

<script>
import SideMenuService from '../../services/SideMenuService';

export default {
  methods: {
    onClickMenuItem() {
      SideMenuService.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

li {
  padding: 1rem 0;
  position: relative;
  isolation: isolate;

  a {
    display: block;
    width: 100%;
    color: var(--dark, $dark);
  }
  .btn-link,
  a {
    &:hover {
      text-decoration: none;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: -1.25rem;
    right: -1.25rem;
    z-index: -1;
    background-color: transparent;
    transition: background-color 0.15s ease;
  }
}

@media (hover: hover) and (pointer: fine) {
  li:hover::before,
  li:focus-within::before {
    background-color: var(--primary-lighter-9, var(--primary));
  }

  li:first-child:hover::before,
  li:first-child:focus-within::before {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  li:last-child:hover::before,
  li:last-child:focus-within::before {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  li:hover a,
  li:focus-within a {
    transform: translateX(0.125rem);
    transition: transform 0.22s ease;
  }
}

@media (hover: none), (pointer: coarse) {
  li:active::before {
    background-color: var(--primary-lighter-9, var(--primary));
  }

  li:first-child:active::before {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  li:last-child:active::before {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  li:active {
    transform: scale(0.995);
  }
}
</style>
